import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import superAdminLoginService from "./superAdminLoginService";

interface SuperAdminPrivacyPolicy {
  superAdminPrivacyData: any;
  isError: boolean;
  isSuccess: boolean;
  isLoading: boolean;
  message: string;
}

const initialState: SuperAdminPrivacyPolicy = {
  superAdminPrivacyData: "",
  isError: false,
  isSuccess: false,
  isLoading: false,
  message: "",
};

//to get privacy policy
export const superAdminPrivacyPolicy = createAsyncThunk("auth/privacy-policy", async (_, thunkAPI) => {
  try {
    const response = await superAdminLoginService.superAdminGetPrivacyPolicy();
    if (response.isSuccess) {
      return response;
    } else {
      throw new Error(response.message);
    }
  } catch (error: any) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const superAdminPrivacyPolicySlice = createSlice({
  name: "privacyPolicy",
  initialState,
  reducers: {
    resetSuperAdminPrivacyPolicy: (state) => {
      state.superAdminPrivacyData = "";
      state.isLoading = false;
      state.isSuccess = false;
      state.isError = false;
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(superAdminPrivacyPolicy.pending, (state, action: PayloadAction<any>) => {
        state.isLoading = true;
      })
      .addCase(superAdminPrivacyPolicy.fulfilled, (state, action: PayloadAction<any>) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.superAdminPrivacyData = action.payload;
      })
      .addCase(superAdminPrivacyPolicy.rejected, (state, action: PayloadAction<any>) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      });
  },
});

export const { resetSuperAdminPrivacyPolicy } = superAdminPrivacyPolicySlice.actions;
